import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import * as React from "react";
import { resolve } from "url";
import { withPrefix, navigate } from "gatsby";
import throttle from "lodash.throttle";
import { useNavbarHeight } from "../../hooks";
import { removeTrailingSlash } from "./../../ui/utils";
import UserMenu from "../UserComponents/Menu";
import { REDOC_OVERVIEW_ITEM_ID } from "../../../constants";

function useActiveSectionId(a, b) {
  var _React$useState = React.useState(""),
      c = _React$useState[0],
      d = _React$useState[1],
      e = useNavbarHeight(a),
      f = React.useCallback(throttle(function () {
    var a = document.querySelectorAll("[data-section-id]");
    if (2 > a.length) return void d("");

    for (var _b = 0; _b < a.length; _b++) {
      var _c = a[_b],
          _f = _c.getBoundingClientRect();

      if (_f.y < e + 5 && _f.bottom > e + 5) return void d(_c.getAttribute("data-section-id") || "");
    }

    b ? d("") : d(a[0] && a[0].getAttribute("data-section-id") || "");
  }, 150), [a, e]);

  return React.useEffect(function () {
    return window.addEventListener("scroll", f, {
      capture: !1
    }), setTimeout(function () {
      f();
    }, 0), function () {
      window.removeEventListener("scroll", f);
    };
  }, [a, e]), c;
}

export function Menu(a) {
  function b(a, c, f, g) {
    if (g === void 0) {
      g = "";
    }

    return a.map(function (a) {
      if (null != c && null != a.apiVersionId) {
        var _b2 = f === null || f === void 0 ? void 0 : f.find(function (b) {
          return b.id === a.apiVersionId;
        });

        if (_b2 && a.apiVersionId !== c) return null;
        if (!_b2 && !a.isDefaultApiVersion) return null;
      }

      if (null == c && null != a.apiVersionId && !a.isDefaultApiVersion) return null;
      var h = d(a, g);
      return _objectSpread(_objectSpread({}, a), {}, {
        items: b(a.items || [], c, f, g),
        active: h,
        hasActiveSubItem: h || e(a, g)
      });
    }).filter(Boolean);
  }

  function c(a, b) {
    for (var _iterator = _createForOfIteratorHelperLoose(a), _step; !(_step = _iterator()).done;) {
      var _d = _step.value;
      if (_d.pageId === b) return _d.link && _d.link.split("#")[1] || "";

      if (_d.items) {
        var _a = c(_d.items, b);

        if (_a) return _a;
      }
    }

    return "";
  }

  function d(b, c) {
    if (c === void 0) {
      c = "";
    }

    var d = a.location,
        e = d.pathname;
    if (!b.link) return !1;

    var _ref = b.link && b.link.split("#"),
        f = _ref[0],
        g = _ref[1];

    return !(decodeURIComponent(removeTrailingSlash(e)) !== decodeURIComponent(removeTrailingSlash(withPrefix(resolve(e, f))))) && (isOverviewPage(b) ? !c : !g || g === (c || ""));
  }

  function e(a, b) {
    if (b === void 0) {
      b = "";
    }

    var c = a.items || [];
    return d(a, b) || c.some(function (a) {
      return e(a, b);
    });
  }

  var f = a.items,
      g = a.location,
      h = a.apiVersionId,
      i = a.className,
      j = a.context,
      k = a.apiVersions,
      l = a.pageId,
      m = useActiveSectionId(g, isOverviewPage({
    pageId: l
  })) || k && c(f, l),
      _React$useState2 = React.useState(b(f, h, k, m)),
      n = _React$useState2[0],
      o = _React$useState2[1];

  React.useEffect(function () {
    o(b(f, h, k, m));
  }, [g, f, h, k, m]);
  var p = useNavbarHeight(g),
      q = React.useCallback(function (a) {
    var b = k === null || k === void 0 ? void 0 : k.find(function (b) {
      return b.id === a.value;
    }),
        c = b !== null && b !== void 0 && b.isDefault ? "" : "@" + (b === null || b === void 0 ? void 0 : b.id);
    var d = findDifferentVersionOfReferencePage({
      items: f
    }, l.split("@")[0] + c, g.hash.substr(1)) || findFirstItemOfReference({
      items: f
    }, b === null || b === void 0 ? void 0 : b.id, l.split("#")[0]);
    d && d.link && navigate(d.link);
  }, [f, l, h, k, g.hash]);
  return /*#__PURE__*/React.createElement(UserMenu, {
    navbarHeight: p,
    items: n,
    context: j,
    className: i,
    location: g,
    apiVersionId: h,
    apiVersions: k,
    onVersionChange: q
  });
}

function findDifferentVersionOfReferencePage(a, b, c) {
  if (!a) return null;

  if (a.pageId === b) {
    var _split = (a.link || "").split("#"),
        _b3 = _split[1];

    if (a.link && !_b3 && !c) return a;
    if (c === _b3) return a;
  }

  for (var _iterator2 = _createForOfIteratorHelperLoose(a.items || []), _step2; !(_step2 = _iterator2()).done;) {
    var d = _step2.value;

    var _a2 = findDifferentVersionOfReferencePage(d, b, c);

    if (_a2) return _a2;
  }

  return null;
}

function findFirstItemOfReference(a, b, c) {
  if (!a) return null;
  if (a.pageId && a.pageId.split("#")[0] === c && a.apiVersionId === b && a.link) return a;

  for (var _iterator3 = _createForOfIteratorHelperLoose(a.items || []), _step3; !(_step3 = _iterator3()).done;) {
    var d = _step3.value;

    var _a3 = findFirstItemOfReference(d, b, c);

    if (_a3) return _a3;
  }

  return null;
}

function isOverviewPage(a) {
  if (!a.pageId) return !1;
  var b = a.pageId.split("@")[0];
  return b.endsWith("#" + REDOC_OVERVIEW_ITEM_ID) && !a.redocFakePage;
}